module.exports = __webpack_public_path__ + "static/media/icon-register.b8045345.svg";